const FromToInputSuffix = ({ inputSuffix }) => (
  <span className="input-group-text" style={{ padding: '0 .8rem' }}>
    {inputSuffix}
  </span>
)

export default FromToInputSuffix
